import React from "react";
import { useLang } from "@/i18n";
import { HOME_COPY as C, HOME_JOURNEY } from "@/data/homeContent";
import { HomeMedia } from "./HomeMedia";
import { Reveal, SectionLabel, TextLink } from "./HomePrimitives";

export const HomeOrigin = () => {
  const { t } = useLang();
  return <section className="rh-origin" data-testid="home-origin">
    <div className="rh-origin-route rh-wrap" data-testid="home-origin-route">{t(C.originRoute)}</div>
    <div className="rh-farm-scene">
      <HomeMedia name="finca" sizes="100vw" className="rh-farm-media" />
      <div className="rh-farm-shade" />
      <div className="rh-farm-title rh-wrap">
        <SectionLabel testId="home-origin-heading" number="04">{t(C.originPlace)}</SectionLabel>
        <p className="rh-statement" data-testid="home-origin-statement">{t(C.originHeading)}</p>
        <span className="rh-farm-coordinate" data-testid="home-origin-altitude">1.800 m · 100% ARÁBICA</span>
      </div>
    </div>
    <div className="rh-origin-intro rh-wrap">
      <Reveal><p className="rh-origin-lead" data-testid="home-origin-lead">{t(C.originIntro)}</p></Reveal>
      <div><p className="rh-body">{t(C.originBody)}</p><TextLink to="/finca" testId="home-finca-link">{t(C.farmLink)}</TextLink></div>
    </div>
    <div className="rh-journey rh-wrap">
      <div className="rh-journey-photo"><figure><HomeMedia name="harvest" sizes="(max-width: 767px) 90vw, 42vw" /><figcaption>{t(C.harvestCaption)}</figcaption></figure></div>
      <div className="rh-journey-copy">
        <p className="rh-statement" data-testid="home-journey-title">{t(C.earthToCup)}</p>
        <ol data-testid="home-coffee-journey">
          {HOME_JOURNEY.map((step, index) => <li key={step.id} data-testid={`finca-secuencia-step-${step.id}`}><Reveal><span className="rh-step-number">0{index + 1}</span><div><h3>{t(step.title)}</h3><p>{t(step.body)}</p></div><span aria-hidden="true">↓</span></Reveal></li>)}
        </ol>
      </div>
    </div>
  </section>;
};